import {OriginalStaticLandingPageVo} from '../../common/shared/api/nicolas/vo/page/OriginalStaticLandingPageVo.interface';
import {
  GroupType,
  LayoutType,
  Maybe,
  MetaInfoType,
  SectionType,
  StaticLandingOriginalParamInput,
  StaticLandingOriginalSection,
  StaticLandingType,
  User,
} from '../generated/types';
import {createCardViewItem} from './CardViewItem';
import {createPosterViewItem} from './PosterViewItem';
import {createSortOption} from './SortOption';
import {createStaticLandingOriginalSectionParam} from './StaticLandingOriginalSectionParam';

export function createStaticLandingOriginalSection(
  userInfo: Maybe<User>,
  {
    sectionId,
    originalStaticLandingPageVo: vo,
    input,
    type = LayoutType.Landing,
  }: {
    sectionId?: string;
    originalStaticLandingPageVo: OriginalStaticLandingPageVo;
    input: StaticLandingOriginalParamInput;
    type?: LayoutType;
  }
): StaticLandingOriginalSection {
  const param = createStaticLandingOriginalSectionParam(vo, input);

  return {
    id:
      sectionId ||
      `static-landing-${StaticLandingType.Original}-section-${type}-${
        param.categoryUid
      }-${param.subcategory?.param}-${param.sortType?.param}-${
        param.isComplete
      }-${input.screenUid ? `-${input.screenUid}-` : ''}`,
    type: SectionType.LandingOriginal,
    groups: [
      {
        id: `static-landing-${StaticLandingType.Original}-group-${
          param.categoryUid
        }-${param.subcategory?.param}${
          input.screenUid ? `-${input.screenUid}` : ''
        }-${param.sortType?.param}-${param.isComplete}`,
        type: GroupType.PosterView,
        items:
          vo.list?.map(item =>
            createPosterViewItem(userInfo, {
              itemSeriesDto: item,
              metaInfoType: MetaInfoType.ViewCount,
            })
          ) || [],
      },
    ],
    subcategoryList:
      vo.subcat_opt?.map(opt => createSortOption({sortOptVo: opt})) || [],
    sortTypeList:
      vo.sort_opt?.map(opt => createSortOption({sortOptVo: opt})) || [],
    recommendItemList:
      vo.recommend_item?.map(item =>
        createCardViewItem(userInfo, {
          itemSeriesDto: item,
        })
      ) || [],
    isEnd: vo.is_end,
    totalCount: vo.total_count,
    originalCount: vo.original_count,
    title: vo.title,
    param,
  };
}
